import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { MeNodeFragmentDoc } from '../fragments/meNode.generated';
import { CarSubModelNodeFragmentDoc } from '../fragments/carSubModelNode.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CarQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type CarQuery = { __typename?: 'Query', car?: { __typename?: 'CarNode', id: string, creationTime?: any | null, updateTime?: any | null, creationYear: number, vehicleCode?: string | null, number: string, frameSerialNumber?: string | null, km?: number | null, color?: string | null, licenceExpDate?: any | null, insuranceExpDate?: any | null, lastCheckInTime?: any | null, rentalTime?: any | null, purchaseTime?: any | null, saleTime?: any | null, salePrice?: number | null, notes?: string | null, damages?: string | null, parkingLocation?: string | null, insuranceCompanyName?: string | null, status: Types.CarCarStatusChoices, createUser?: { __typename?: 'MeNode', id: string, username: string, firstName?: string | null, lastName?: string | null, email?: string | null, isReadOnly: boolean, lastLogin?: any | null, isSuperuser: boolean, userPermissions?: Array<string | null> | null, dateJoined?: any | null } | null, updateUser?: { __typename?: 'MeNode', id: string, username: string, firstName?: string | null, lastName?: string | null, email?: string | null, isReadOnly: boolean, lastLogin?: any | null, isSuperuser: boolean, userPermissions?: Array<string | null> | null, dateJoined?: any | null } | null, carSubModel: { __typename?: 'CarSubModelNode', id: string, name: string, localName?: string | null, carModel: { __typename?: 'CarModelNode', id: string, name: string, localName?: string | null, brand: { __typename?: 'BrandNode', id: string, name: string } } }, driver?: { __typename?: 'DriverNode', id: string, email?: string | null, name: string } | null, bank?: { __typename?: 'BankNode', id: string, name: string } | null, activeDeal?: { __typename?: 'DealNode', id: string } | null } | null };


export const CarDocument = gql`
    query Car($id: ID!) {
  car(id: $id) {
    id
    creationTime
    updateTime
    createUser {
      ...MeNode
    }
    updateUser {
      ...MeNode
    }
    carSubModel {
      ...CarSubModelNode
    }
    creationYear
    vehicleCode
    number
    frameSerialNumber
    km
    color
    licenceExpDate
    insuranceExpDate
    lastCheckInTime
    rentalTime
    purchaseTime
    saleTime
    salePrice
    notes
    damages
    parkingLocation
    insuranceCompanyName
    status
    driver {
      id
      email
      name
    }
    bank {
      id
      name
    }
    activeDeal {
      id
    }
    activeDeal {
      id
    }
  }
}
    ${MeNodeFragmentDoc}
${CarSubModelNodeFragmentDoc}`;

/**
 * __useCarQuery__
 *
 * To run a query within a React component, call `useCarQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCarQuery(baseOptions: Apollo.QueryHookOptions<CarQuery, CarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarQuery, CarQueryVariables>(CarDocument, options);
      }
export function useCarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarQuery, CarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarQuery, CarQueryVariables>(CarDocument, options);
        }
export type CarQueryHookResult = ReturnType<typeof useCarQuery>;
export type CarLazyQueryHookResult = ReturnType<typeof useCarLazyQuery>;
export type CarQueryResult = Apollo.QueryResult<CarQuery, CarQueryVariables>;